import React from 'react'

import {
  titleCont,
  container,
  subtitleCont,
  linkCont,
} from './index.module.css'

import Button from '../Button/'
import Link from '../Link'

const CenteredText = ({ title, subtitle, ctaText, ctaUrl }) => {
  return (
    <div className={container}>
      <h2 className={titleCont}>{title}</h2>
      <div className={subtitleCont}>{subtitle.subtitle}</div>
      {ctaText && ctaUrl && (
        <div className={linkCont}>
          <Link to={ctaUrl}>
            <Button>{ctaText}</Button>
          </Link>
        </div>
      )}
    </div>
  )
}

export default CenteredText
